import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { VEHICLES, checkDocs } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";
import { DocUpload } from "./DocUpload";
import { NextBtn, StepHead } from "./StepBar";

const MODES = [["foto", "CNH física (frente e verso)"], ["digital", "CNH digital"]];

function CnhFields({ f, patch, code }) {
  const cat = VEHICLES.find((v) => v.id === f.vehicle)?.cnh;
  const doc = (kind, label, hint, pdf) => <DocUpload code={code} kind={kind} label={label} hint={hint} pdf={pdf} value={f[kind]} onChange={(v) => patch({ [kind]: v })} />;
  return (
    <div className="space-y-3">
      <div role="alert" className="flex gap-3 rounded-xl border border-amber-500/50 bg-amber-500/10 p-4 text-sm font-semibold text-amber-800 dark:text-amber-200" data-testid="boy-docs-cnh-warning">
        <AlertTriangle className="h-5 w-5 shrink-0" />
        <span>Sua CNH precisa estar válida e na categoria correspondente ao veículo escolhido.{cat && ` (Categoria ${cat})`}</span>
      </div>
      <div className="grid grid-cols-2 gap-2 rounded-full bg-muted p-1" role="radiogroup">
        {MODES.map(([k, l]) => (
          <button key={k} type="button" role="radio" aria-checked={f.cnhMode === k} onClick={() => patch({ cnhMode: k })} data-testid={`boy-docs-mode-${k}`}
            className={cn("rounded-full px-2 py-2 text-xs font-semibold transition-colors sm:text-sm", f.cnhMode === k ? "bg-background shadow-sm" : "text-muted-foreground")}>{l}</button>
        ))}
      </div>
      {f.cnhMode === "digital" ? doc("cnh_digital", "CNH digital", "PDF ou print da CNH digital", true) : (
        <div className="grid grid-cols-2 gap-3">
          {doc("cnh_front", "Frente da CNH", "Toque para fotografar")}
          {doc("cnh_back", "Verso da CNH", "Toque para fotografar")}
        </div>
      )}
    </div>
  );
}

export function StepDocs({ f, patch, code, onNext }) {
  const bike = f.vehicle === "bike";
  const go = (e) => {
    e.preventDefault();
    const m = checkDocs(f);
    if (m) return toast.error(m);
    onNext();
  };
  return (
    <form onSubmit={go} className="space-y-5" data-testid="boy-step-docs">
      <StepHead title="Agora, vamos validar seus documentos." text="Tire uma foto nítida dos documentos. Evite reflexos e fundos escuros." />
      {!bike && <CnhFields f={f} patch={patch} code={code} />}
      <div className="space-y-2">
        <p className="text-sm font-medium">{bike ? "Selfie segurando um documento com foto" : "Selfie segurando a CNH"}</p>
        <DocUpload code={code} kind="selfie" selfie label="Sua selfie" hint={bike ? "Segure o RG ou a CNH ao lado do rosto" : "Segure a CNH ao lado do rosto"}
          value={f.selfie} onChange={(v) => patch({ selfie: v })} />
      </div>
      <NextBtn testid="boy-step-docs-next">Enviar Documentos</NextBtn>
    </form>
  );
}
